module.exports = __webpack_public_path__ + "static/media/PROD_ASS1.f4b4f3d4.png";